var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/"}},[_c('BaseLogo',{staticClass:"logo pointer-cursor logo-img",class:{'logo-img--small': _vm.small},attrs:{"locale":_vm.$i18n.locale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }